export default "__VITE_ASSET__CBeEDr_6__"